import React from 'react';
import PropTypes from 'prop-types';

import {
  getStorage,
  updateStorage
} from '../../../utils/storage';


import Loading from '../../../components/loading';
import Navigator from '../../../components/navigator';
import PageHeader from '../../../components/page-header';

import SeqLoadSummary from './upload/summary';
import UploadPanel from './upload/upload-panel';
import GsheetTable from './gtable_seq';
import GsheetTableIso from './gtable_iso';
import GsheetTableMutation from './gtable_mut';

import {handleLoadSeqFromHIVDB} from './hivdb/load-db';

import GTable from '../../../components/gsheet/gtable';


export default class Isolate extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired
    }).isRequired
  };

  constructor() {
    super(...arguments);
    this.state = {
      loading: true,
      rawDataCollection: null,
      isNavClick: false,
      nextPathName: null,
      rawDataUpdatedAt: new Date().toISOString(),
    };
  }

  set processing(value) {
    if (value) {
      this.setState({
        loading: true,
      });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  async componentDidMount() {
    const {location: {query}} = this.props;
    const {rawDataCollection} = (await getStorage(query.load));
    this.setState({
      rawDataCollection: rawDataCollection,
      rawDataUpdatedAt: new Date().toISOString(),
    });

    await handleLoadSeqFromHIVDB(rawDataCollection);
    // console.log(rawDataCollection);

    this.setState({
      rawDataCollection: rawDataCollection,
      rawDataUpdatedAt: new Date().toISOString(),
    });
    this.handleSave();

    this.processing = false;
  }

  async handleSave() {
    const {location: {pathname}} = this.props;
    const {rawDataCollection} = this.state;

    const state = {
      pathname: pathname,
      rawDataCollection
    };
    await updateStorage(state);
  }

  async handleUpdate(rawDataCollection) {
    this.setState({
      rawDataCollection: rawDataCollection,
      rawDataUpdatedAt: new Date().toISOString(),
    });
    await this.handleSave();
  }

  async handleSubmit(e) {
    e && e.preventDefault();

    const {rawDataCollection} = this.state;

    const state = {
      pathname: this.props.location.pathname,
      rawDataCollection
    };

    const load = await updateStorage(state);
    const {sequenceType, hasClinicalIsolate} = rawDataCollection;

    let pathname = '/wizard/rx-list';
    if (sequenceType === 'incomplete') {
      pathname = hasClinicalIsolate ?
        '/wizard/rx-list' : '/wizard/susc-results';
    }

    const {nextPathName} = this.state;
    if (nextPathName) {
      pathname = nextPathName;
    }
    this.context.router.push({
      pathname,
      query: {load}
    });
  }


  get gsheet_table() {
    const {rawDataCollection} = this.state;

    if (rawDataCollection.sequenceType === 'incomplete') {
      return this.gsheet_mutation;
    } else {
      return this.gsheet_sequence;
    }

  }

  get gsheet_mutation() {
    const {rawDataCollection} = this.state;

    const {isNavClick} = this.state;

    return (
      <GsheetTableMutation
       key={this.state.rawDataUpdatedAt}
       rawDataCollection={rawDataCollection}
       onUpdate={
         this.handleUpdate.bind(this)}
       onSubmit={
         this.handleSubmit.bind(this)}
       isNavClick={isNavClick}
       onCleanPathName={
         this.handleCleanPathName.bind(this)}
      />
    );
  }

  get gsheet_sequence() {
    const {rawDataCollection} = this.state;

    if (!rawDataCollection.hasRawSequences) {
      return null;
    }

    const {isNavClick} = this.state;

    if (!rawDataCollection.hasAllSeqMeta) {
      return (
        <GsheetTableIso
         key={this.state.rawDataUpdatedAt}
         rawDataCollection={rawDataCollection}
         onUpdate={
           this.handleUpdate.bind(this)}
         onSubmit={() => {}}
         isNavClick={isNavClick}
         onCleanPathName={
           this.handleCleanPathName.bind(this)}
        />
      );
    }

    return (
      <GsheetTable
       key={this.state.rawDataUpdatedAt}
       rawDataCollection={rawDataCollection}
       onUpdate={
         this.handleUpdate.bind(this)}
       onSubmit={
         this.handleSubmit.bind(this)}
       isNavClick={isNavClick}
       onCleanPathName={
         this.handleCleanPathName.bind(this)}
      />
    );
  }

  handleNavClick(pathname) {
    const {isNavClick} = this.state;
    this.setState({
      isNavClick: !isNavClick,
      nextPathName: pathname,
    });
  }

  handleCleanPathName() {
    this.setState({
      nextPathName: null
    });
  }

  render() {
    const {loading} = this.state;
    if(loading) {
      return (
        <div>
          <Loading />
        </div>
      );
    }

    const {rawDataCollection} = this.state;
    const {references} = rawDataCollection;
    const isCompleteSequence = rawDataCollection.sequenceType === 'incomplete';

    return (
      <div>
        <Navigator
         rawDataCollection={rawDataCollection}
         onNavClick={this.handleNavClick.bind(this)}
        />
        <PageHeader references={references} />
        <UploadPanel
         rawDataCollection={rawDataCollection}
         onUpdate={this.handleUpdate.bind(this)}
        />
        {isCompleteSequence ? null :
        <SeqLoadSummary
         key={this.state.rawDataUpdatedAt + '_summary'}
         rawDataCollection={rawDataCollection}
        />
        }
        {this.gsheet_table}
        <GTable
         spreadsheet_id={rawDataCollection.spreadsheet_id}
         sheet_id={rawDataCollection.sheet_id}
         ></GTable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/index.js